export var conditionIsFilled = function conditionIsFilled(condition) {
  return condition.operator && condition.property && condition.value;
};